import type { ReactNode } from 'react';
import { PinMark } from './PinMark';

type EmptyStateProps = {
  title: string;
  note: string;
  action?: ReactNode;
};

/**
 * The shared empty-state recipe (docs/DESIGN.md): the pin, one display line, one muted sentence,
 * and the one action that fills the screen. Never an apology, never a dead end.
 */
export function EmptyState({ title, note, action }: EmptyStateProps) {
  return (
    <section className="flex flex-col items-start gap-2 rounded-[var(--radius)] border border-dashed p-6">
      <PinMark size={26} className="opacity-60" />
      <p className="text-2xl" style={{ fontFamily: 'var(--font-heading)', fontWeight: 600 }}>
        {title}
      </p>
      <p className="max-w-prose opacity-80">{note}</p>
      {action}
    </section>
  );
}
